module.exports = {"520201011":"黄土坡街道","520201012":"红岩街道","520201013":"荷泉街道","520201014":"荷城街道","520201015":"杨柳街道","520201016":"凤凰街道","520201017":"德坞街道","520201018":"月照街道","520201019":"双戛街道","520201101":"大河镇","520201102":"汪家寨镇","520201103":"大湾镇","520201104":"木果镇","520201105":"保华镇","520201202":"金盆苗族彝族乡","520201203":"南开苗族彝族乡","520201204":"青林苗族彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520201.json
// module id = 2589
// module chunks = 0